<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-card class="rounded-card elevation-6 pa-3">
          <v-toolbar dark color="primary lighten-2">
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat color="white" small outline @click="signup"
              >Sign Up?</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <span v-if="stage === 1" class="caption mb-4"
              >Which team are you logging into?</span
            >
            <v-alert
              v-if="error"
              :value="true"
              type="error"
              icon="warning"
              class="mb-4"
              v-html="errorMessage"
            >
              {{ errorMessage }}
            </v-alert>
            <v-form
              id="loginForm"
              ref="form"
              v-model="valid"
              lazy-validation
              class="my-2"
              @submit.prevent
            >
              <div v-if="stage === 0">
                <v-text-field
                  v-model="email"
                  id="email"
                  prepend-icon="email"
                  ref="email"
                  label="Email Address"
                  type="text"
                  :rules="emailRules"
                  validate-on-blur
                  required
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  prepend-icon="lock"
                  ref="password"
                  label="Password"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="[v => !!v || 'Password is required']"
                  required
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </div>
              <div v-if="stage === 1">
                <v-select
                  v-model="team"
                  :items="teams"
                  item-value="_id"
                  item-text="name"
                  prepend-icon="group"
                  ref="team"
                  label="Team"
                  hint="Choose the team you wish to login to"
                  persistent-hint
                  required
                  class="mt-3"
                ></v-select>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="stage === 1"
              color="primary"
              round
              outline
              @click="prev"
              >Back</v-btn
            >
            <v-btn
              :disabled="!valid"
              type="submit"
              color="accent"
              form="loginForm"
              round
              block
              :loading="loading"
              @click="validate"
              >Login</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-btn
          flat
          color="secondary"
          small
          text
          class="text-lowercase font-weight-thin"
          @click="forgotEmail"
          >Forgot your password?</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'login',
  tryAgain: 'Unable to login at this time. Please try again in a few moments.',
  data: () => ({
    showPassword: false,
    verified: false,
    error: false,
    errorMessage: 'Error.',
    stage: 0,
    loading: false,
    valid: true,
    email: null,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid'
    ],
    password: null,
    team: {},
    teams: []
  }),
  mounted: function() {
    if (this.$route.query.email) {
      const email = decodeURIComponent(this.$route.query.email);
      if (email && typeof email !== 'undefined') {
        this.email = email;
        if (this.$route.query.ev) {
          this.verified = !!this.$route.query.ev;
        }
      }
    }
    // this is a hack to stop the weird chrome label overlay mess
    const element = this.$el.querySelector('#email');
    if (element) {
      this.$nextTick(() => {
        element.focus();
      });
    }
    // this.$refs.email.focus();
    // this.$refs.password.focus();
  },
  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.error = false;
        this.errorMessage = '';
        if (this.stage === 0) {
          try {
            const response = await this.login({
              email: this.email,
              password: this.password
            });
            // eslint-disable-next-line
            // console.log('AUTH response: ', response);
            this.loading = false;
            if (response && response.success === false) {
              if (response.statusCode === 101) {
                this.teams = response.teams;
                this.team = response.teams[0];
                this.team = await this.lastTeam({
                  email: this.email,
                  teamId: response.teams[0]
                });
                this.stage = 1;
              } else {
                this.errorMessage = response.message;
                this.error = true;
              }
            } else if (response && response.success) {
              if (this.verified) {
                // eslint-disable-next-line
                // console.log('Auto verifying email');
                this.loading = true;
                await this.verify({
                  userId: response.user._id,
                  email: response.user.email
                });
                this.loading = false;
              }
              this.setSnack('Login successful');
              console.log('LOGIN RESPONSE (1):', response);
              this.$ga.event({
                eventCategory: 'account',
                eventAction: 'login',
                eventLabel: response.user.email
              });
              if (
                response.account.status === 'ACTIVE' ||
                response.account.status === 'FREE'
              ) {
                this.$router.replace(
                  this.$route.query.redirect || '/downloads'
                ); // was dashboard
              } else {
                this.$router.replace('/accountstatus');
              }
              // this.$router.push('/dashboard');
            } else if (response && response.message) {
              this.errorMessage = response.message;
              this.error = true;
            } else {
              this.errorMessage = this.$options.tryAgain;
              this.error = true;
            }
          } catch (error) {
            this.loading = false;
            this.errorMessage = error.message;
            this.error = true;
          }
        } else {
          // form should be complete now
          try {
            const response = await this.login({
              email: this.email,
              password: this.password,
              teamId: this.team
            });
            this.loading = false;
            // eslint-disable-next-line
            // console.log('AUTH response 2: ', response);
            if (response && response.success) {
              if (this.verified) {
                // eslint-disable-next-line
                // console.log('Auto verifying email');
                this.loading = true;
                await this.verify({
                  userId: response.user._id,
                  email: response.user.email
                });
                this.loading = false;
              }
              this.setSnack('Login successful');
              this.$ga.event({
                eventCategory: 'account',
                eventAction: 'login',
                eventLabel: response.user.email
              });
              console.log('LOGIN RESPONSE (2):', response);
              if (response.account.status === 'ACTIVE') {
                this.$router.replace(
                  this.$route.query.redirect || '/downloads'
                );
              } else {
                this.$router.replace('/accountstatus');
              }
              // this.$router.push('/dashboard');
            } else {
              this.errorMessage = response
                ? response.message
                : this.$options.tryAgain;
              this.error = true;
            }
          } catch (error) {
            this.loading = false;
            // eslint-disable-next-line
            // console.log('AUTH  error response: ', error);
            this.errorMessage = error.message;
            this.error = true;
          }
        }
      }
    },
    forgotEmail() {
      if (this.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.$router.push(`/forgot?email=${encodeURIComponent(this.email)}`);
      } else {
        this.$router.push('/forgot');
      }
    },
    signup() {
      if (this.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.$router.push(`/signup?email=${encodeURIComponent(this.email)}`);
      } else {
        this.$router.push('/signup');
      }
    },
    prev() {
      this.error = false;
      this.errorMessage = '';
      this.stage = 0;
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      verify: 'account/verifyEmail',
      login: 'auth/login',
      lastTeam: 'auth/lastTeam'
    })
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
